import  utils from '../components/utils.js';

var SharedStyle = Backbone.Model.extend({
	toCSS: function () {
		return '.' + utils.getSharedClassName(this) + '{' + this.get('css') + '}';
	}
});

export default SharedStyle;
